import { render } from "./MainContents.vue?vue&type=template&id=2802772b"
import script from "./MainContents.vue?vue&type=script&lang=js"
export * from "./MainContents.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MainContents.vue?vue&type=style&index=0&id=2802772b&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__